/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateFormConfigDto } from '../models';
// @ts-ignore
import type { FormConfigDetailDto } from '../models';
// @ts-ignore
import type { FormsConfigControllerGetFormConfigs200Response } from '../models';
// @ts-ignore
import type { SortFormSectionsDto } from '../models';
// @ts-ignore
import type { UpdateFormConfigDto } from '../models';
/**
 * FormsConfigApi - axios parameter creator
 * @export
 */
export const FormsConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerCompareFormConfigJsons: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forms-config/compare-jsons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFormConfigDto} createFormConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerCreateFormConfig: async (createFormConfigDto: CreateFormConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormConfigDto' is not null or undefined
            assertParamExists('formsConfigControllerCreateFormConfig', 'createFormConfigDto', createFormConfigDto)
            const localVarPath = `/api/forms-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerDeleteFormConfig: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsConfigControllerDeleteFormConfig', 'formId', formId)
            const localVarPath = `/api/forms-config/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerExportFormConfigJson: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsConfigControllerExportFormConfigJson', 'formId', formId)
            const localVarPath = `/api/forms-config/export-json/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerFixDraftDataCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forms-config/fix-draft-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerGetFormConfigDetail: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsConfigControllerGetFormConfigDetail', 'formId', formId)
            const localVarPath = `/api/forms-config/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [code] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerGetFormConfigs: async (name?: string, code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forms-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerImportUserFormConfigJson: async (formId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsConfigControllerImportUserFormConfigJson', 'formId', formId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('formsConfigControllerImportUserFormConfigJson', 'file', file)
            const localVarPath = `/api/forms-config/import-user-json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (formId !== undefined) { 
                localVarFormParams.append('formId', formId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {SortFormSectionsDto} sortFormSectionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerSortFormSections: async (formId: string, sortFormSectionsDto: SortFormSectionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsConfigControllerSortFormSections', 'formId', formId)
            // verify required parameter 'sortFormSectionsDto' is not null or undefined
            assertParamExists('formsConfigControllerSortFormSections', 'sortFormSectionsDto', sortFormSectionsDto)
            const localVarPath = `/api/forms-config/sort-sections/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sortFormSectionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {UpdateFormConfigDto} updateFormConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerUpdateFormConfig: async (formId: string, updateFormConfigDto: UpdateFormConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('formsConfigControllerUpdateFormConfig', 'formId', formId)
            // verify required parameter 'updateFormConfigDto' is not null or undefined
            assertParamExists('formsConfigControllerUpdateFormConfig', 'updateFormConfigDto', updateFormConfigDto)
            const localVarPath = `/api/forms-config/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsConfigApi - functional programming interface
 * @export
 */
export const FormsConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerCompareFormConfigJsons(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerCompareFormConfigJsons(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerCompareFormConfigJsons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFormConfigDto} createFormConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerCreateFormConfig(createFormConfigDto: CreateFormConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerCreateFormConfig(createFormConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerCreateFormConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerDeleteFormConfig(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerDeleteFormConfig(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerDeleteFormConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerExportFormConfigJson(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerExportFormConfigJson(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerExportFormConfigJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerFixDraftDataCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerFixDraftDataCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerFixDraftDataCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerGetFormConfigDetail(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormConfigDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerGetFormConfigDetail(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerGetFormConfigDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [code] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerGetFormConfigs(name?: string, code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormsConfigControllerGetFormConfigs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerGetFormConfigs(name, code, search, orderBy, orderDirection, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerGetFormConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerImportUserFormConfigJson(formId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerImportUserFormConfigJson(formId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerImportUserFormConfigJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {SortFormSectionsDto} sortFormSectionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerSortFormSections(formId: string, sortFormSectionsDto: SortFormSectionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerSortFormSections(formId, sortFormSectionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerSortFormSections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {UpdateFormConfigDto} updateFormConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formsConfigControllerUpdateFormConfig(formId: string, updateFormConfigDto: UpdateFormConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formsConfigControllerUpdateFormConfig(formId, updateFormConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormsConfigApi.formsConfigControllerUpdateFormConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormsConfigApi - factory interface
 * @export
 */
export const FormsConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerCompareFormConfigJsons(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsConfigControllerCompareFormConfigJsons(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateFormConfigDto} createFormConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerCreateFormConfig(createFormConfigDto: CreateFormConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsConfigControllerCreateFormConfig(createFormConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerDeleteFormConfig(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsConfigControllerDeleteFormConfig(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerExportFormConfigJson(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.formsConfigControllerExportFormConfigJson(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerFixDraftDataCodes(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsConfigControllerFixDraftDataCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerGetFormConfigDetail(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<FormConfigDetailDto> {
            return localVarFp.formsConfigControllerGetFormConfigDetail(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [code] 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerGetFormConfigs(name?: string, code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<FormsConfigControllerGetFormConfigs200Response> {
            return localVarFp.formsConfigControllerGetFormConfigs(name, code, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerImportUserFormConfigJson(formId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsConfigControllerImportUserFormConfigJson(formId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {SortFormSectionsDto} sortFormSectionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerSortFormSections(formId: string, sortFormSectionsDto: SortFormSectionsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsConfigControllerSortFormSections(formId, sortFormSectionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {UpdateFormConfigDto} updateFormConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsConfigControllerUpdateFormConfig(formId: string, updateFormConfigDto: UpdateFormConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formsConfigControllerUpdateFormConfig(formId, updateFormConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormsConfigApi - object-oriented interface
 * @export
 * @class FormsConfigApi
 * @extends {BaseAPI}
 */
export class FormsConfigApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerCompareFormConfigJsons(options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerCompareFormConfigJsons(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateFormConfigDto} createFormConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerCreateFormConfig(createFormConfigDto: CreateFormConfigDto, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerCreateFormConfig(createFormConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerDeleteFormConfig(formId: string, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerDeleteFormConfig(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerExportFormConfigJson(formId: string, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerExportFormConfigJson(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerFixDraftDataCodes(options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerFixDraftDataCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerGetFormConfigDetail(formId: string, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerGetFormConfigDetail(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [name] 
     * @param {string} [code] 
     * @param {string | null} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerGetFormConfigs(name?: string, code?: string, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerGetFormConfigs(name, code, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerImportUserFormConfigJson(formId: string, file: File, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerImportUserFormConfigJson(formId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {SortFormSectionsDto} sortFormSectionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerSortFormSections(formId: string, sortFormSectionsDto: SortFormSectionsDto, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerSortFormSections(formId, sortFormSectionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {UpdateFormConfigDto} updateFormConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsConfigApi
     */
    public formsConfigControllerUpdateFormConfig(formId: string, updateFormConfigDto: UpdateFormConfigDto, options?: RawAxiosRequestConfig) {
        return FormsConfigApiFp(this.configuration).formsConfigControllerUpdateFormConfig(formId, updateFormConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}

